import { IntlShape } from 'react-intl';
import { NewBornGranularity, NewBornTimelinePointDTO } from '../../dto/newborn/NewBornDTO';
import { periodTitle } from '../ServicesStatistics/TimelineChart';
import { toTimelinePoint } from './newBornEvolutionModel';

const dayMonth = (intl: IntlShape, date: Date): string => intl.formatDate(date, { day: '2-digit', month: '2-digit' });

/**
 * El nombre de un período: «Semana del 14/09 al 20/09» o «Septiembre 2026». Las fechas son las efectivas dentro del rango:
 * una semana recortada dice sus días reales, y un mes recortado los aclara («Septiembre 2026, del 01/09 al 28/09»).
 */
export function periodTitleOf(intl: IntlShape, point: NewBornTimelinePointDTO, granularity: NewBornGranularity): string {
    const timeline = toTimelinePoint(point);
    const title = periodTitle(intl, timeline, granularity);
    if (granularity === 'WEEK' || !point.partial) return title;
    return intl.formatMessage({ id: 'NewBornPeriodMonthPartial' }, {
        month: title, from: dayMonth(intl, timeline.start), to: dayMonth(intl, timeline.end),
    });
}
